import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${
      queryFilter.sort
    },${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/evento/tipo_eventos${queryUrl}`)
  },
  insertNewEventType(data) {
    return axios.post('/evento/tipo_eventos', data)
  },
  editEventType(data) {
    return axios.put(`/evento/tipo_eventos/${data.id}`, data)
  },
  deleteEventType(id) {
    return axios.delete(`/evento/tipo_eventos/${id}`)
  },
}
